"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const genStyle_1 = require("../genStyle");
const constants_1 = require("../../../elements/course/LandingSectionLayout/constants");
const styleSchema = {
    indents: {
        paddingTop: (0, genStyle_1.genStyle)({ value: 50 }),
        paddingBottom: (0, genStyle_1.genStyle)({ value: 20 }),
    },
    effect: {
        fadeEffect: (0, genStyle_1.genStyle)({ value: true }),
    },
};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: {}, feedback: {} } };
